var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"symbol symbol-35 symbol-light-success"},[(_vm.url)?_c('img',{attrs:{"alt":"","src":_vm.url}}):_c('span',{staticClass:"symbol-label font-size-h5 font-weight-bold",staticStyle:{"background-color":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }